import React from 'react';

function About() {
  return (
    // Like a ghost element that does not show in the DOM
    <React.Fragment>
      <h1>About</h1>
      <p>
        This is the Todo app build with React on the fronent and a Python
        Serverless REST API on AWS on the backend. Both the frontend and the
        backend were developed by me.
      </p>
    </React.Fragment>
  );
}

export default About;
